import { withChartLayout } from 'components/common';
import ConsentForBloodTransfusion from 'components/features/chart/special-charts/consent-for-blood-transfusion/ConsentForBloodTransfusion';

const ConsentForBloodTransfusionPage = withChartLayout('Consent for Blood Transfusion')(ConsentForBloodTransfusion);
export default ConsentForBloodTransfusionPage;
